import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectCreateInput } from 'gql/graphql';
import { useSetIsWorkOrderChangeRequired } from 'pages/Project/BimProject/hooks/useSetIsWorkOrderChangeRequired';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimCreateWorkOrderObjectGql } from '../../bimWorkOrderQueries';

const requestId = 'bimCreateWorkOrderObject';

export const useBimCreateWorkOrderObject = (workOrderId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [bimCreateWorkOrderObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimCreateWorkOrderObjectReset(undefined);
        onSuccess?.();
    }, [bimCreateWorkOrderObjectReset, onSuccess]);

    const [
        bimCreateWorkOrderObjectData,
        bimCreateWorkOrderObjectStatus,
        bimCreateWorkOrderObjectError,
        bimCreateWorkOrderObjectRequest,
    ] = useRequest({
        requestId,
        query: bimCreateWorkOrderObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    useSetIsWorkOrderChangeRequired({
        useData: { isWorkOrderChangeRequired: true },
        status: bimCreateWorkOrderObjectStatus,
    });

    const bimCreateWorkOrderObjectMakeRequest = useCallback(
        (input: BimContractObjectCreateInput) => {
            dispatch(bimCreateWorkOrderObjectRequest({ workOrderId, input }));
        },
        [bimCreateWorkOrderObjectRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        bimCreateWorkOrderObjectReset(undefined);
    }, [bimCreateWorkOrderObjectReset]);

    return {
        bimCreateWorkOrderObjectData,
        bimCreateWorkOrderObjectStatus,
        bimCreateWorkOrderObjectError,
        bimCreateWorkOrderObjectMakeRequest,
    };
};
